import { create } from 'zustand';
import { adminArticleApi } from '@api/api-config.ts';
import { ArticleListResponse, ArticleTargetType } from '@api/generated/portal-be-admin';

export interface ArticleFilters {
  q?: string;
  targetType?: ArticleTargetType;
  isUrgent?: boolean;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminArticleStoreState {
  loading: boolean;
  error: string | null;
  data: ArticleListResponse[] | null;
  pagination: PaginationInfo | null;
  loadArticles: (filters: ArticleFilters) => Promise<void>;
}

export const useAdminArticleStore = create<AdminArticleStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,

  loadArticles: async (filters: ArticleFilters) => {
    try {
      set({ loading: true, error: null });
      const response = await adminArticleApi.getArticles({
        page: filters.page,
        size: filters.size,
        q: filters.q,
        targetType: filters.targetType,
        isUrgent: filters.isUrgent,
      });
      const result = response.data;
      set({
        loading: false,
        error: null,
        data: result.items || [],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba při načítání článků',
      });
    }
  },
}));
